<template>
    <section id="what-we-do">
        <b-container fluid>
            <h2 class="section-title mb-2 h1">
                Productos disponibles <b>({{ filteredproducts.length }})</b>
            </h2>
            
            <b-row
                v-for="row in Math.ceil(filteredproducts.length / numberOfColumns)"
                :key="row"
            >
                <b-col
                    v-for="product in filteredproducts.slice((row - 1) * numberOfColumns, row * numberOfColumns)"
                    :key="product.id"
                >
                    <b-card :title="Marca(product.marca)">
                        <div :class="'card-block ' + blockRandom()">
                            <h4 class="card-title">
                                #ASSET TAG: {{ product.asset }}
                            </h4>
                            <p class="card-text">
                                #Serial: {{ product.Serial }}<br />
                                Año: {{ product.model_year }}<br />
                                Precio: {{ product.price }}<br />
                                Disponibe: {{ available(product.available) }}
                            </p>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </section>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
      data () {
        return {
          numberOfColumns: 3
        }
      },
      computed: {
        ...mapGetters(['filteredproducts'])
      },
      methods: {
        available (bool) {
          return bool ? 'Sí' : 'No'
        } ,
        Marca (Marca) {
          return `Marca: ${Marca}`
        },
        Model (Model) {
          return `Modelo: ${Model}`
        },
        blockRandom () {
          return `block-${Math.floor(Math.random() * 6) + 1}`
        }
      }
    }
</script>
<style>
    @import "../assets/search.css";
</style>